import { Route } from '@angular/router';

export const appRoutes: Route[] = [
  {
    path: '',
    loadChildren: () => import('./modules/landing/landing.routes'),
  },
  {
    path: 'manager',
    loadChildren: () =>
      import('./modules/manager/manager.routes').then((m) => m.default),
  },
  {
    path: 'tenant',
    loadChildren: () => import('./modules/tenant/tenant.routes'),
  },
  // TODO: Deprecate shortener module routes in favor of l/:code route
  {
    path: 's',
    loadChildren: () => import('./modules/shortener/shortener.routes'),
  },
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth.routes'),
  },
  {
    path: 'public',
    loadChildren: () => import('./modules/public/public.routes'),
  },
  {
    path: 'l/:code',
    loadComponent: () =>
      import('./modules/shortener/short-link-redirect.component').then(
        (m) => m.ShortLinkRedirectComponent,
      ),
  },
  {
    path: '404',
    title: 'Page Not Found',
    loadComponent: () =>
      import('./pages/404/404.component').then((m) => m.Rc404PageComponent),
  },
  {
    path: '**',
    title: 'Page Not Found',
    loadComponent: () =>
      import('./pages/404/404.component').then((m) => m.Rc404PageComponent),
  },
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full',
  },
];
